/*
view_dotpay

dotpay = {
    "utimestamp": 1458224412998,
    "am": "50",
    "bid": null,
    "paymentMethodId": 23,
},
*/

import core from '../../common/lib/core.js';
// import validateAmount from '../lib/validate-amount.js';
import validateDotpay from '../lib/validate-dotpay.js';
import viewTextkeys from '../../commonview/lib/view-textkeys.js';

const create = core.create;
const classnameShow = 'u-show';
const classnameHide = 'u-hide';
const notvalidClass = 'payment__input_notvalid';
let textkeysObj;

function createNumberTitle(txt) {
	const elm = create({
		type: 'legend',
		class: 'legend'
	});
	if (txt) {
		elm.innerHTML = txt;
	}
	return elm;
}

function createLabelNumber() {
	return create({
		type: 'label',
		class: 'payment__label-code-dotpay'
	});
}

function createFeedback(txt) {
	const elm = create({
		type: 'small',
		class: 'input-wrap__error-display payment__feedback grid-u-sm-1 u-hide'
	});
	if (txt) {
		elm.innerHTML = txt;
	}
	return elm;
}

function createInputCode(placeholder) {
	return create({
		type: 'input',
		class: 'payment__input-dotpay input-wrap__input',
		name: 'code',
		'input-type': 'tel',
		placeholder: (placeholder || 'enter blik code here')
	});
}

function createFieldsetWrapNumber(eventFilter) {
	const cName = `${eventFilter} payments__fieldset-wrap-number u-relative`;
	return create({
		type: 'div',
		class: cName
	});
}

function validAmount() {
	/* remove any trailing spaces from all input and validate */
	// const theInput = core.trailspace(elements.inputamount.value || null);
	// checks for amount valid and if errorClass is present in the field.
	// return ((validateAmount.keepDigits(theInput) && !containsWord(elements.inputamount.className, errorClass)) ? theInput : null);
	return 'view_dotpay:93';
}

function replace(elm, val) {
	elm.value = val; // eslint-disable-line no-param-reassign
}

function getInput(elements) {
	/* check if the current input is done with 6 digits, and flag
	for not complete input (123, 12, 1, 12345, 1234) */
	const theInput = core.trailspace(elements.inputcode.value || null);
	const isOnlyDigits = validateDotpay.containsOnlyDigits(theInput);
	const tooShort = validateDotpay.hasStringLengthLessThan(theInput, 6);
	const filteredToValid = validateDotpay.filterAwayNotValid(theInput);
	const isValid = validateDotpay.code(filteredToValid);
	return {
		theInput,
		isOnlyDigits,
		tooShort,
		filteredToValid,
		isValid
	};
}

function validCode(elements) {
	/* remove any trailing spaces from all input and validate */
	const theInput = core.trailspace(elements.inputcode.value || null);
	return (validateDotpay.code(theInput) ? theInput : null);
}

function userInputToSubmitStructure(elements) {
	/* This is the structure required by the depositmethod. To not hardcode keys in earlier steps the values are parsed here. */
	const am = validAmount(elements);
	const blik = validCode(elements);
	const allvalid = Boolean(am && blik);
	return {
		am,
		blik,
		allvalid,
		utimestamp: new Date().getTime(),
		paymentMethodId: 57
	};
}

function show(elm) {
	core.removeClass(elm, classnameHide);
	core.addClass(elm, classnameShow);
}

function hide(elm) {
	core.removeClass(elm, classnameShow);
	core.addClass(elm, classnameHide);
}

function hideElm(elm, yesHideIt) {
	if (yesHideIt) {
		hide(elm);
	} else {
		show(elm);
	}
}

function markValid(element, valid) {
	if (valid) {
		core.removeClass(element, notvalidClass);
	} else {
		core.addClass(element, notvalidClass);
	}
}

function feedbackToCode(inputIsValid, elms) {
	if (inputIsValid) {
		markValid(elms.labelcardnumber, true);
		hide(elms.cardnumberfeedback);
	} else {
		markValid(elms.labelcardnumber, false);
		hideElm(elms.cardnumberfeedback, false);
	}
}

function markValidAll(uInput, elements) {
	/* depending on validation the inputfields are marked
    with specific classname and messages with feedback are shown */
	const code = (uInput && uInput.blik);
	feedbackToCode(code, elements);
}
function mainHandler(e, onEventCb, eventFilterSeparatorClassname) {
	const eventFilterSelector = `.${eventFilterSeparatorClassname}`;

	function cb(p) {
		p.e.stopPropagation();
		p.e.preventDefault();
		onEventCb();
	}
	/* If the last argument is set to 'true', the handler function runs the callback if the .fkn_filter element or any of its children (#content_A,#content_B,#inner_content) is clicked */
	core.handle(e, eventFilterSelector, cb, true);
}

function addListeners(elm, cbOnEvent, eventFilter, eventType) {
	function handleCreator(e) {
		mainHandler(e, cbOnEvent, eventFilter);
	}
	core.addListener(elm, eventType, handleCreator);
	return handleCreator;
}

function removeListeners(elm, handler, eventType) {
	if (elm) {
		core.removeListener(elm, eventType, handler);
	}
}

export default {
	create() {
		let elements = {};
		const mainEventType = 'input';
		const classNameEventFilter = 'js-eventfilter-viewdotpay';
		elements.wrap = (elements.wrap || createFieldsetWrapNumber(classNameEventFilter));

		const callbackOnMainEvent = function callbackOnMainEvent() {
			// if the input is more than 6 digits or is not a number 0-9 the input may be erased
			const current = getInput(elements);
			const hasInput = current.theInput;
			const isDigitsAndNotCompleted = !hasInput || (current.tooShort && current.isOnlyDigits); // do not set 'not valid' until all numbers are input
			const valid = (isDigitsAndNotCompleted || current.isValid);
			replace(elements.inputcode, current.filteredToValid);
			feedbackToCode(valid, elements);
		};
		const handler = addListeners(elements.wrap, callbackOnMainEvent, classNameEventFilter, mainEventType);

		textkeysObj = viewTextkeys.depositflow();
		elements.inputcode = (elements.inputcode || createInputCode(textkeysObj['dotpay-enter-code-placeholder']));
		elements.labelcardnumber = (elements.labelcardnumber || createLabelNumber());
		elements.cardnumberTitle = (elements.cardnumberTitle || createNumberTitle(textkeysObj['dotpay-code-title']));
		elements.cardnumberfeedback = (elements.cardnumberfeedback || createFeedback(textkeysObj['dotpay-code-feedback']));
		elements.labelcardnumber.appendChild(elements.cardnumberTitle);
		elements.labelcardnumber.appendChild(elements.inputcode);
		elements.labelcardnumber.appendChild(elements.cardnumberfeedback);
		elements.wrap.appendChild(elements.labelcardnumber);

		return {
			wrap: elements.wrap,
			show() {
				show(elements.wrap);
			},
			hide() {
				hide(elements.wrap);
			},
			update() {
			},
			evalInput() {
				let uinput = userInputToSubmitStructure(elements);
				markValidAll(uinput, elements);
				uinput = (uinput.allvalid ? uinput : null);
				return uinput;
			},
			close() {
				/* hide the spinner if the spinner is closed before hidden.
				Otherwise the '.dim' element will remain on the parent */
				removeListeners(elements.wrap, handler, mainEventType);
				elements = core.deleteElementsInObjectExcept(elements, [], 'view_dotpay:248');
				return null;
			}
		};
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/payment/lib/view-dotpay.js